export default "__VITE_ASSET__7a0b685f__"